import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';

export const SecureRoute = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState.isAuthenticated) {
      // Land on /login (Sign in with Okta button) rather than redirecting
      // straight to Okta's hosted login page.
      const originalUri = window.location.pathname + window.location.search;
      oktaAuth.setOriginalUri(originalUri);
      navigate('/login', { replace: true });
    }
  }, [oktaAuth, authState, navigate]);

  if (!authState || !authState.isAuthenticated) {
    return (
      <div className="centered">
        <div className="spinner" />
        <p className="muted">Authenticating...</p>
      </div>
    );
  }

  return <Outlet />;
};
